import { HttpHandler } from 'msw'

import { createDeliveryMan } from './createDeliveryMan'
import { deleteDeliveryMan } from './deleteDeliveryMan'
import { getAllDeliveryMen } from './getAllDeliveryMen'
import { getDeliveryMan } from './getDeliveryMan'
import { updateDeliveryMan } from './updateDeliveryMan'

export const deliveryMen: HttpHandler[] = [
    createDeliveryMan,
    deleteDeliveryMan,
    getAllDeliveryMen,
    getDeliveryMan,
    updateDeliveryMan,
]
